import Vue from 'vue'
import Router from 'vue-router'
// import store from '@/store'

Vue.use(Router)
const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      meta: {
        title: '寓喵管家'
      },
      component: () => import('@/pages/h5/download')
    },
    {
      path: '/h5/empty-list/:id',
      meta: {
        title: '房源列表',
        scrollTop: 0,
        keepAlive: true
      },
      component: () => import('@/pages/h5/empty-list'),
    },
    {
      path: '/h5/house-detail/:id',
      meta: {
        title: '房源详情'
      },
      component: () => import('@/pages/h5/house-detail'),
    },
    {
      path: '/h5/contract-detail/:id',
      meta: {
        title: '电子合同'
      },
      component: () => import('@/pages/h5/contract-detail')
    },
    {
      path: '/h5/preview-contract',
      meta: {
        title: '预览合同'
      },
      component: () => import('@/pages/h5/preview-contract')
    },
    {
      path: '/h5/sign/:id',
      meta: {
        title: '合同签名'
      },
      component: () => import('@/pages/h5/sign')
    },
    {
      path: '/h5/data-export/:id',
      meta: {
        title: '数据导出'
      },
      component: () => import('@/pages/h5/data-export')
    },
    {
      path: '/h5/download',
      meta: {
        title: '下载app'
      },
      component: () => import('@/pages/h5/download')
    },
    {
      path: '/h5/invite',
      meta: {
        title: '下载app'
      },
      component: () => import('@/pages/h5/invite-register')
    },
    {
      path: '/h5/agreement',
      meta: {
        title: '用户协议'
      },
      component: () => import('@/pages/h5/agreement')
    },
    {
      path: '/h5/privacy',
      meta: {
        title: '隐私政策'
      },
      component: () => import('@/pages/h5/privacy')
    },
    //wechat
    {
      path: '/h5/talent/talent-bind', //租客绑定
      meta: {
        title: '租客绑定'
      },
      component: () => import('@/pages/h5/talent/talent-bind')
    },
    {
      path: '/h5/talent/talent', //租客管理
      meta: {
        title: '合同列表',
      },
      component: () => import('@/pages/h5/talent/talent')
    },
    {
      path: '/h5/talent/contract/:id',
      meta: {
        title: '合同详情'
      },
      component: () => import('@/pages/h5/talent/contract')
    },
    {
      path: '/h5/talent/bill-detail/:id', //账单列表
      meta: {
        title: '账单详情',
      },
      component: () => import('@/pages/h5/talent/bill-detail')
    },
    {
      path: '/h5/landlord/landlord-login', //房东绑定
      meta: {
        title: '房东绑定'
      },
      component: () => import('@/pages/h5/landlord/landlord-login')
    },
    {
      path: '/h5/landlord/landlord', //房东管理
      meta: {
        title: '房东管理',
        loginCheck: true,
      },
      component: () => import('@/pages/h5/landlord/landlord')
    }


  ]
})

router.beforeEach((to, from, next) => {
  const isLogin = localStorage.getItem('token');
  const isNeedLoginCheck = to.matched.some(record => record.meta.loginCheck)
  if (isNeedLoginCheck && !isLogin) {
    next('/h5/landlord/landlord-login?redirect=' + to.path)
    return false
  }
  if (from.meta.keepAlive) {
    const $content = document.querySelector('#list');
    const scrollTop = $content ? $content.scrollTop : 0;
    from.meta.scrollTop = scrollTop;
  }
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
